export function removeAccent(text: string): string {
  const withoutAccentText = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  return withoutAccentText;
}
